<template>
  <div>
    <div>
      <div>
        <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close ="(val) => toast = val"/>
        <br>
        <tl-accordion headerName="Personal Information" :active="true">
          <div slot="accordionBody">
              <form-personal-info @personal="(val)=>personal=val"></form-personal-info>
              <br>
          </div>
        </tl-accordion>
        <tl-accordion headerName="Official Information">
          <div slot="accordionBody">
              <form-official-info @official="(val)=>official=val"></form-official-info>
              <br>
          </div>
        </tl-accordion>
        <tl-accordion headerName="Previous Employers Details">
          <div slot="accordionBody">
              <form-previous-employer-info :active="true" @previousEmployer="(val)=>previousEmployer=val"></form-previous-employer-info>
              <br>
          </div>
        </tl-accordion>
        <tl-accordion headerName="Salary Details">
          <div slot="accordionBody">
              <form-salary-detail @salary="(val)=>salaryinfo=val"></form-salary-detail>
              <br>
          </div>
        </tl-accordion>
        <tl-accordion headerName="PF & ESI">
          <div slot="accordionBody">
              <form-pf-esi @pfesi="(val)=>pfesi=val"></form-pf-esi>
              <br>
          </div>
        </tl-accordion>
        <tl-accordion headerName="Bank Details">
          <div slot="accordionBody">
              <form-bank-detail @bankinfo="(val)=>bankinfo=val"></form-bank-detail>
              <br>
          </div>
        </tl-accordion>
        <!-- <tl-accordion headerName="Documents">
          <div slot="accordionBody">
              <form-documents @documents="(val)=>documents=val"></form-documents>
              <br>
          </div>
        </tl-accordion> -->
      </div>
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="continuee" />
          <btn :text="btnText" type="primary" @click="save" />
        </btn-grp>
      </template>
    </bottom-action-container>

    <pop-up-message
      v-if="showPopup"
      :message="`Employee Created Successfully`"
      btnText="Back"
      @back="backfrompopup()"
    />
  </div>
</template>

<script>
import FormPersonalInfo from './form_personal_info.vue';
import FormPreviousEmployerInfo from './form_previous_employer_info.vue';
import FormOfficialInfo from './form_official_info.vue';
import FormSalaryDetail from './form_salary_detail.vue';
import FormPfEsi from './form_pf_esi.vue';
import FormBankDetail from './form_bank_detail.vue';
// import FormDocuments from './form_documents.vue';
import { mapGetters,mapActions } from 'vuex';

export default {
  data() {
    return {
      personalInfo: false,
      previousEmployer: false,
      officialInfo: false,
      salaryDetails: false,
      pfEsi: false,
      bankDetails: false,
      documents: false,
      personal:{},
      previousEmployer: {},
      btnText:"",
      official:{},
      salaryinfo:{},
      pfesi:{},
      bankinfo:{},
      showPopup:false,
      errmsg: "",
      toast: false,
    }
  },
  components: {
    FormPersonalInfo,
    FormPreviousEmployerInfo,
    FormOfficialInfo,
    FormSalaryDetail,
    FormPfEsi,
    FormBankDetail,
    // FormDocuments
  },
    computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
      // orgid: "onboard/organization/orgid"
    }),

    le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
      // return "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a";
    }
    },
    mounted(){
      //console.log('queryPath',this.$route.path.split("/")[this.$route.path.split("/").length-1]);
      let lastRoutePath = this.$route.path.split("/")[this.$route.path.split("/").length-1];
      if(lastRoutePath == "employees"){
        this.btnText = "Add Employee";
      }
      else{
        this.btnText = "Next"
      }
    },
  methods: {
    ...mapActions({
      'act_create':"onboard/employees/create"
    }),
    async save() {
      // save data
      // this.$router.push({
      //   path:  `/onboarding/entity/${this.$route.params.entity_index}/employees/employeeDashboard`
      // })
       //console.log('Add employee insideee',this.official)
       if(this.official.band_id==''){
         this.official.band_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
        if(this.official.grade_id==''){
         this.official.grade_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
        if(this.official.designation_id==''){
         this.official.designation_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
       if(this.official.level_id == ''){
         this.official.level_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
        if(this.official.department_id==''){
         this.official.department_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }

        if(this.official.cost_center_id==''){
         this.official.cost_center_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
         if(this.official.paygroup_id==''){
         this.official.paygroup_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
         if(this.official.location_id==''){
         this.official.location_id="727459e8-685b-4c62-af4c-8ec465feebc2"
       }
       let obj= {
             'personal':{...this.personal,
                               ...{"legal_entity_id" : this.le_id,
                                        "father_name" : null,
                                        "mother_name" : null,
                                        "anniversary_date" : null,
                                        "pan_photo_url" : null,
                                        "adhar_photo_url" : null,
                                        "passport_number" : null,
                                        "passport_photo_url" : null
                                      }},
             'official':{...this.official,...{"last_working_day":null,"retirement_date":null}},
             'previousEmployer':{...this.previousEmployer,...{"last_working_day":null,"retirement_date":null}},
             'salary_detail':{...this.salaryinfo,...{"send_payslips_automatically": true}},
             'pfesi':{...this.pfesi},
             'bank':{...this.bankinfo}
             }
      //console.log('Add employee',obj)
      try{
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj);
        setTimeout(() => {
          if(res.status){
            this.showPopup = true;
          }
          this.$root._data.isSaving = false;
        }, 500);
      }catch(err){
        this.$root._data.isSaving = false;
        //console.log('addemploye',err)
        this.toast = true;
        this.errmsg = err;
      }
    },
    backfrompopup(){
      this.showPopup = false
      this.personal = {},
      this.previousEmployer = {},
      this.official = {},
      this.salaryinfo={},
      this.pfesi = {},
      this.bankinfo={}
    },
    continuee(){
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

</style>
